/* -----------------------------------------------------------
 * AUTO-GENERATED — DO NOT EDIT.
 *
 *   source:  /app/backend/boutiques.py
 *   emitter: python -m scripts.sync_boutique_registry_to_frontend
 *
 * `test_boutique_registry.py::test_frontend_mirror_in_sync` fails if this
 * file drifts from the backend canonical. To change a boutique's identity
 * (name, market, tint, status), edit the backend registry then re-run the
 * emitter — never hand-edit this file.
 * ---------------------------------------------------------- */

export const BOUTIQUE_RECORDS = [
  {
    "code": "FLL",
    "id": "b_FLL",
    "name": "Blue Massage of Fort Lauderdale",
    "shortName": "Fort Lauderdale",
    "market": "South Florida",
    "state": "FL",
    "colorFamily": "blue",
    "presenceTint": "fll",
    "active": true,
    "status": "launched"
  },
  {
    "code": "PLT",
    "id": "b_PLT",
    "name": "Green Massage of Plantation",
    "shortName": "Plantation",
    "market": "South Florida",
    "state": "FL",
    "colorFamily": "green",
    "presenceTint": "plt",
    "active": true,
    "status": "launched"
  },
  {
    "code": "PNC",
    "id": "b_PNC",
    "name": "Orange Massage of Pinecrest",
    "shortName": "Pinecrest",
    "market": "South Florida",
    "state": "FL",
    "colorFamily": "orange",
    "presenceTint": "pnc",
    "active": true,
    "status": "launched"
  },
  {
    "code": "WYN",
    "id": "b_WYN",
    "name": "Pink Massage of Wynwood",
    "shortName": "Wynwood",
    "market": "South Florida",
    "state": "FL",
    "colorFamily": "pink",
    "presenceTint": "wyn",
    "active": true,
    "status": "launched"
  },
  {
    "code": "CC",
    "id": "b_CC",
    "name": "Red Massage of Cherry Creek",
    "shortName": "Cherry Creek",
    "market": "Denver",
    "state": "CO",
    "colorFamily": "red",
    "presenceTint": "cc",
    "active": true,
    "status": "in_setup"
  },
  {
    "code": "RNO",
    "id": "b_RNO",
    "name": "Yellow Massage of RiNo",
    "shortName": "RiNo",
    "market": "Denver",
    "state": "CO",
    "colorFamily": "yellow",
    "presenceTint": "rno",
    "active": true,
    "status": "in_setup"
  },
  {
    "code": "RBW",
    "id": "b_RBW",
    "name": "Rainbow Interests",
    "shortName": "Rainbow",
    "market": "Corporate",
    "state": null,
    "colorFamily": "pearl",
    "presenceTint": "rainbow",
    "active": true,
    "status": "launched"
  }
];

export const MARKET_ORDER = ["South Florida", "Denver", "Corporate"];
